import { connect } from 'react-redux';
import storage from 'app/services/storage';
import layoutModule from 'app/store/layout';
import eventsModule from 'app/store/events';
import cinemasModule from 'app/store/cinemas';
import EventDetails from './EventDetails.component';

const { clearErrorApi } = layoutModule.actions;
const { requestEventDetails, resetEventDetails, requestAllEvents, setEventDetails } = eventsModule.actions;

const { requestMovieOperaSessions, requestMovieOperaScreens, setMovieOperaSessions, setMovieOperaScreens } = cinemasModule.actions;
const mapDispatchToProps = {
  clearErrorApi,
  getEventDetails: requestEventDetails,
  resetState: resetEventDetails,
  getAllEvents: requestAllEvents,
  fetchMovieOperaSessions: requestMovieOperaSessions,
  fetchMovieOperaScreens: requestMovieOperaScreens,
  setEventDetails,
  setMovieOperaSessions,
  setMovieOperaScreens
};

const mapStateToProps = ({ events, user }) => (
  {
    eventDetails: events.eventDetails,
    movies: events.movies,

    isLoggedIn: !!user.user,
    savedLocation: storage.getLocation()
  });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventDetails);
